import React from "react";

export type IconName =
  | "arrow" | "check" | "truck" | "award" | "shield" | "laptop" | "upload" | "box"
  | "piggy" | "palette" | "gauge" | "headset";

export function Icon({ name, className }: { name: IconName; className?: string }) {
  return (
    <svg className={className} aria-hidden="true">
      <use href={`#i-${name}`} />
    </svg>
  );
}

const stroke = {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
};

export function IconSprite() {
  return (
    <svg width="0" height="0" className="absolute" aria-hidden="true">
      <defs>
        <symbol id="i-arrow" viewBox="0 0 24 24" {...stroke} strokeWidth="2.2"><path d="M5 12h14M13 6l6 6-6 6" /></symbol>
        <symbol id="i-check" viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="11" fill="#0B5FFF" />
          <path d="M7 12.5l3.2 3.2L17 9" fill="none" stroke="#fff" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
        </symbol>
        <symbol id="i-truck" viewBox="0 0 24 24" {...stroke} strokeWidth="1.6">
          <path d="M2 6h11v10H2zM13 9h4l4 4v3h-8z" /><circle cx="6.5" cy="17.5" r="1.8" /><circle cx="17.5" cy="17.5" r="1.8" />
        </symbol>
        <symbol id="i-award" viewBox="0 0 24 24" {...stroke} strokeWidth="1.6">
          <circle cx="12" cy="9" r="6" /><path d="M9 14l-2 7 5-3 5 3-2-7" /><path d="M9.5 9l1.8 1.8L15 7.2" />
        </symbol>
        <symbol id="i-shield" viewBox="0 0 24 24" {...stroke} strokeWidth="1.6">
          <path d="M12 3l8 3v6c0 4.5-3.2 7.8-8 9-4.8-1.2-8-4.5-8-9V6z" /><path d="M8.5 12l2.5 2.5 4.5-5" />
        </symbol>
        <symbol id="i-laptop" viewBox="0 0 24 24" {...stroke} strokeWidth="1.4">
          <rect x="4" y="4" width="16" height="11" rx="1.5" /><path d="M2 19h20M6 13l3.5-4 3 3 2-2 3 3" /><circle cx="9" cy="7.5" r="1" />
        </symbol>
        <symbol id="i-upload" viewBox="0 0 24 24" {...stroke} strokeWidth="1.4">
          <path d="M7 18a4.5 4.5 0 01-.6-8.96A6 6 0 0118 8.5 4.5 4.5 0 0117 18" /><path d="M12 21v-9M8.5 15.5L12 12l3.5 3.5" />
        </symbol>
        <symbol id="i-box" viewBox="0 0 24 24" {...stroke} strokeWidth="1.4">
          <path d="M12 2.5l9 4.5v10l-9 4.5-9-4.5V7z" /><path d="M3 7l9 4.5L21 7M12 11.5v10M7.5 4.8l9 4.6" />
        </symbol>
        <symbol id="i-piggy" viewBox="0 0 24 24" {...stroke} strokeWidth="1.4">
          <path d="M19 10.5c1.5.3 2 1 2 2.5v2h-2.3c-.8 1.6-2.2 2.7-4 3.2V20h-3v-1.5H9V20H6v-2.6C4.4 16.4 3.500 14.700 3.500 13c0-3.300 3.200-6 7.500-6 1 0 2 .15 2.900.45L16 6v2.500c1.200.5 2.200 1.200 3 2z" />
          <circle cx="15.500" cy="11.500" r=".6" fill="currentColor" /><path d="M9 5.500c.5-.9 1.500-1.500 2.800-1.500" />
        </symbol>
        <symbol id="i-palette" viewBox="0 0 24 24" {...stroke} strokeWidth="1.4">
          <path d="M12 3a9 9 0 100 18c1.400 0 2-1 1.600-2.100-.4-1 .2-2.100 1.400-2.100H17a4 4 0 004-4c0-5-4-9.800-9-9.800z" />
          <circle cx="7.500" cy="11" r="1" /><circle cx="10" cy="7" r="1" /><circle cx="15" cy="7" r="1" />
        </symbol>
        <symbol id="i-gauge" viewBox="0 0 24 24" {...stroke} strokeWidth="1.4">
          <path d="M3.500 17a9 9 0 1117 0" /><path d="M12 14l4-5" /><circle cx="12" cy="14.500" r="1.200" /><path d="M6 12l.8.4M9 8.500l.4.8M15 8.500l-.4.8" />
        </symbol>
        <symbol id="i-headset" viewBox="0 0 24 24" {...stroke} strokeWidth="1.4">
          <path d="M4 14v-2a8 8 0 0116 0v2" /><rect x="3" y="13" width="4" height="6" rx="1.500" /><rect x="17" y="13" width="4" height="6" rx="1.500" /><path d="M19 19c0 1.700-1.800 2.500-4 2.500" />
        </symbol>
      </defs>
    </svg>
  );
}
